import {getConfig} from '../../services/config/configService';

const getOverrideThemeConfig = () => getConfig()?.overrideThemeConfig ?? {};

const getPageConfig = (route) => getOverrideThemeConfig().pages?.find((item) => item.route === route) ?? {};
const getModalsConfig = (modalType) =>
    getOverrideThemeConfig().modals?.find((item) => item.modalType === modalType) ?? {};
const getStoriesConfig = (storiesType) =>
    getOverrideThemeConfig().stories?.find((item) => item.storiesType === storiesType) ?? {};

const configOverrideThemeGetters = {
    getPageConfig,
    getModalsConfig,
    getStoriesConfig,
};

export default configOverrideThemeGetters;
